export const GLOBAL_STATE = 'AssessmentMarks'

export const ASSESSMENT_AMENDMENT = 'markAmendment'
export const ASSESSMENT_AMENDMENT_CREATE = 'markAmendmentCreate'
export const ASSESSMENT_AMENDMENT_LIST = 'markAmendmentList'
export const ASSESSMENT_AMENDMENT_ALL = 'markAmendmentAll'
export const ASSESSMENT_MARK_STATUS = 'markStatus'
